import { type FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { ContentTypeType } from "@/types/graphql/partner.generated";

interface ContentTypeOption {
  value: ContentTypeType;
  label: string;
}

const CONTENT_TYPE_OPTIONS: ContentTypeOption[] = [
  { value: ContentTypeType.VideoType, label: "VIDEO" },
  { value: ContentTypeType.StreamType, label: "STREAM" },
  { value: ContentTypeType.CollectionType, label: "COLLECTION" },
];

interface ContentTypeFieldProps {
  label: string;
  value: string[];
  fullWidth?: boolean;
  /**
   * Убрать тип «эфир» из списка: на развёртывании без живых эфиров
   * (`instance.liveEnabled`) фильтровать по нему нечего. Значение
   * приходит пропом, а не из хука: shared не импортирует entities
   * (eslint boundaries).
   */
  hideStream?: boolean;
  onChange: (contentTypes: string[]) => void;
}

// Мультиселект по существующему GraphQL-enum ContentTypeType (VIDEO/STREAM/
// COLLECTION, @/types/graphql/partner.generated) — тот же enum, что и
// Content.type в ContentsListQuery, отдельного списка не заводим.
export const ContentTypeField: FC<ContentTypeFieldProps> = ({
  label,
  value,
  hideStream = false,
  onChange,
}) => (
  <Autocomplete<ContentTypeOption, true>
    multiple
    fullWidth
    options={CONTENT_TYPE_OPTIONS.filter(
      (option) => !hideStream || option.value !== ContentTypeType.StreamType
    )}
    getOptionLabel={(option) => option.label}
    isOptionEqualToValue={(option, selected) => option.value === selected.value}
    value={CONTENT_TYPE_OPTIONS.filter((option) =>
      value.includes(option.value)
    )}
    onChange={(_event, newValue) =>
      onChange(newValue.map((option) => option.value))
    }
    renderInput={(params) => <TextField {...params} label={label} />}
  />
);
